import React, { useEffect, useState } from "react";
import Styles from './styles.module.scss'
import { useTranslation } from "react-i18next";
import CustomBorder from "../_UI/customBorder";
import {useNavigate} from "react-router-dom";

const ApostolS3 = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkWidth = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkWidth();
        window.addEventListener('resize', checkWidth);

        return () => window.removeEventListener('resize', checkWidth);
    }, []);

    const rewardData = [
        [[10, 10, 10], [10, 10, 10]],
        [[10, 10, 10], [10, 10, 10]],
        [[10, 10, 10], [10, 10, 10]]
    ];

    return (
        <section className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={Styles.title}>{t('Таблица вознаграждений:')}</div>
                <div className={Styles.note}>
                    <span>{t('Всего выделено 5% токенов от общей эмиссии')}</span> {t('они будут распределяться следующим образом:')}
                </div>

                <div className={Styles.contentBox}>
                    {rewardData.map((item, index) => {
                        return (
                            <div className={Styles.contentBoxItem} key={'reawards' + index}>
                                <div className={Styles.line} />
                                <div className={Styles.itemWrap}>
                                    {item.map((itemX, indexX) => {
                                        const titleCorners = isMobile
                                            ? {}
                                            : indexX === 0
                                                ? { topRight: true, bottomLeft: true }
                                                : { topLeft: true, bottomRight: true };

                                        const tableCorners = isMobile
                                            ? {}
                                            : indexX === 0
                                                ? { topLeft: true, bottomRight: true }
                                                : { topRight: true, bottomLeft: true };

                                        return (
                                            <div className={Styles.item} key={index + 'reawardsItem' + indexX}>
                                                <div className={Styles.itemTitle}>
                                                    <CustomBorder
                                                        corners={titleCorners}
                                                        fill="#1A1600"
                                                        borderColor="#FFD700"
                                                    >
                                                        <div className={Styles.text}>
                                                            {t('Ковчег')} {index * 2 + indexX + 1}
                                                        </div>
                                                    </CustomBorder>
                                                </div>

                                                <div className={Styles.itemTableWrap}>
                                                    <CustomBorder
                                                        corners={tableCorners}
                                                        fill="#0d172a"
                                                        borderColor="#FFFFFF"
                                                    >
                                                        <div className={Styles.itemTable}>
                                                            {itemX.map((itemY, indexY) => {
                                                                return (
                                                                    <div
                                                                        className={Styles.itemTableRow}
                                                                        key={indexX + 'tableItem' + indexY}
                                                                    >
                                                                        {indexY + 1} {t('уровень')} {itemY}%
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </CustomBorder>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                                <div className={Styles.line} />
                            </div>
                        );
                    })}

                    <div className={Styles.noteWrap}>
                        <div className={Styles.noteColored}>
                            {t('Апостолы — это не просто партнёры.')} <br />
                            <span>{t('Это архитекторы распространения цифрового будущего.')}</span>
                        </div>

                        <div className={Styles.btnWrap}>
                            <CustomBorder
                                corners={isMobile ? {} : { topRight: true, bottomLeft: true }}
                                fill="#0d172a"
                                borderColor="#FFFFFF"
                                withHover={true}
                            >
                                <button className={Styles.btn} onClick={()=>{navigate('/sign-in')}}>
                                    <div>{t('Стать апостолом')}</div>
                                </button>
                            </CustomBorder>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ApostolS3;